import errorFlash from "./errorFlash"

function handleChange (value, type, ref, countRef, getter, setter) {
    if (value.length > getter.max) {
        ref.current.value = ref.current.value.slice(0, getter.max)
        errorFlash(countRef)
    }
    if (type === "step") setter({value: value, last: getter.value, max: getter.max})
    else if (type === "resource") setter({value: value, max: getter.max})
}

export default handleChange